import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BFormGroup, BInputGroup, BInputGroupAppend, BButton, VBTooltip } from 'bootstrap-vue'
import { KFormSelect } from '@kwixeo/form-vue'
import Select from '@kwixeo/form-vue/dist/components/Select/Select'
import { TranslateResult } from 'vue-i18n'

@Component({
  methods: {
    ...mapActions('dynamicModals', ['openModal'])
  },
  components: {
    KFormSelect,
    BFormGroup, BButton, BInputGroup, BInputGroupAppend,
    FontAwesomeIcon
  },
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class ContactSelect extends Vue {
  openModal!: (params: string|KwixeoInterface.OpenModalParamObject) => void

  @Prop({ default: null }) label!: string|null
  @Prop({ default: null }) value!: KwixeoCustomers.Contact|null
  @Prop({ default: null }) customer!: KwixeoCustomers.Customer|null
  @Prop({ default: true }) withLabel!: boolean
  @Prop({ default: true }) withForm!: boolean
  @Prop({ default: false }) withLink!: boolean|undefined
  @Prop({ default: null }) validationName!: null|string
  @Prop({ default: false }) required!: boolean|undefined
  @Prop({ default: false }) disabled!: boolean|undefined
  @Prop({ default: true }) clearable!: boolean
  @Prop({ default: null }) size!: string|null
  @Prop({ default: null }) labelSize!: string|null
  @Prop({ default: null }) include!: string|string[]|null
  @Prop({ default: () => (contact: KwixeoCustomers.Contact|null) => contact?.fullname }) selectLabel!: (contact: KwixeoCustomers.Contact|null) => string

  private contact: KwixeoCustomers.Contact|null = null

  get computedLabel (): string|TranslateResult {
    return this.label ?? this.$t('customers.contact.label')
  }

  get labelComponent (): string {
    return this.withLabel ? 'b-form-group' : 'div'
  }

  get attributes (): KwixeoInterface.GenericObject {
    const attrs: KwixeoInterface.GenericObject = {
      getOptionLabel: this.selectLabel,
      required: this.required !== false,
      disabled: this.disabled !== false,
      clearable: this.clearable,
      validationName: this.validationName,
      size: this.size
    }

    if (this.customer && this.customer.contacts) {
      attrs.options = this.customer.contacts
    } else {
      attrs.ajax = this.contactApiUrl
    }
    return attrs
  }

  get contactApiUrl (): string {
    let url = '/customer/contact?sort=fullname'
    if (this.customer) {
      url += '&filter[with_customer]=' + this.customer.id
    }
    if (this.include) {
      url += '&include=' + (typeof this.include === 'string' ? this.include : this.include.join(','))
    }
    return url
  }

  @Watch('value', { immediate: true })
  private watchValue (value: KwixeoCustomers.Contact|null): void {
    this.contact = value === null ? null : JSON.parse(JSON.stringify(this.value))
  }

  @Emit('input')
  private onChange (): KwixeoCustomers.Contact|null {
    return this.contact
  }

  // Open modal for create or edit a customer
  private openForm (): void {
    this.openModal({
      key: 'contact-form',
      value: this.contact,
      attributes: {
        customer: this.customer,
        withRedirection: false
      },
      submitted: response => {
        const contact = response.data as KwixeoCustomers.Contact
        this.contact = contact

        const select = this.$refs.select as Select
        select.updateOption(contact)

        this.onChange()
      }
    })
  }

  private async goToItem (): Promise<void> {
    await this.$router.push({
      name: 'contacts-contact-item',
      params: {
        id: String(this.contact?.id)
      }
    })
  }
}
